<template>
  <!-- eslint-disable max-len -->
  <transition name="fade">
    <div
      v-if="!consentGiven"
      class="p-8 z-50 fixed bottom-0 w-full bg-black flex items-center text-white text-4 md:text-3 justify-between min-h-cookies flex-wrap"
    >
      <!-- eslint-disable max-len -->
      <p>
        This site uses cookies. By continuing to browse the site, you are agreeing to our use of cookies. For full details please read our <RouterLink
          class="link"
          :to="{ name: 'legal' }"
        >
          privicy policy
        </RouterLink>
      </p>
      <div
        class="pt-8"
      >
        <CoreButton
          text="Ok, got it"
          @click="acceptCookies"
        />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'BlockCookies',

  data: () => ({
    consentGiven: false,
  }),

  created() {
    this.checkConsent();
  },

  methods: {
    acceptCookies() {
      const consent = 'cookieConsent=true';

      const date = new Date();
      date.setTime(date.getTime() + 90 * 24 * 60 * 60 * 1000); // 90 day expiarey
      const expires = `expires=${date.toUTCString()}`;

      document.cookie = [consent, expires].join(';');
      this.checkConsent();
    },
    checkConsent() {
      this.consentGiven = !!decodeURIComponent(document.cookie)
        .split(';')
        .filter((item) => item
          .trim()
          .startsWith('cookieConsent=')).length;
    },
  },
};
</script>

<style scoped>
.min-h-cookies {
  min-height: 10rem;
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease);
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
